import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

export const TextForOrderParameter: React.FC = () => {
    const { t } = useTwinTranslation()
    const parameters: TwinDictionary = {
        '{assigned_number}': t('assignedReserveTicketNumber', 'Número del ticket de reserva'),
    }
    const renderThis: JSX.Element[] = []
    for (const key in parameters) {
        renderThis.push(<div key={key}><span className='medium14'>{key}</span> - {parameters[key]}</div>)
    }
    return (
        <div className='col-span-3'>
            <span><TwinTrans transKey={'useNextParametersForGeneration'}>Utiliza los siguientes parámetros para la generación automática</TwinTrans>:</span>
            {renderThis}
        </div>
    )
}